declare global {
  interface Window {
    MSStream?: boolean;
  }
}

export const getMobileOperatingSystem = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window['opera'];

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return 'Windows Phone';
  }

  if (/android/i.test(userAgent)) {
    return 'Android';
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'iOS';
  }

  return '';
};

export const iOSVersion = () => {
  if (window['MSStream']) {
    // There is some iOS in Windows Phone...
    // https://msdn.microsoft.com/en-us/library/hh869301(v=vs.85).aspx
    return false;
  }
  const match = navigator.userAgent.match(/OS (\d+)_(\d+)_?(\d+)?/);
  let version: number[] | undefined;

  if (match !== undefined && match !== null) {
    version = [
      parseInt(match[1], 10),
      parseInt(match[2], 10),
      parseInt(match[3] || '0', 10),
    ];
    return parseFloat(version.join('.'));
  }

  return false;
};
